import { render } from "./EditInvoice.vue?vue&type=template&id=496fb88f&scoped=true"
import script from "./EditInvoice.vue?vue&type=script&lang=js"
export * from "./EditInvoice.vue?vue&type=script&lang=js"

import "./EditInvoice.vue?vue&type=style&index=0&id=496fb88f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496fb88f"]])

export default __exports__